import { motion } from "framer-motion";
import { FaTiktok, FaXTwitter, FaSnapchat, FaTelegram } from "react-icons/fa6";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { platforms } from "@/data/content";
import { SectionHeader } from "@/components/SectionHeader";

const icons = {
  tiktok: FaTiktok,
  x: FaXTwitter,
  snapchat: FaSnapchat,
  telegram: FaTelegram,
};

export const Platforms = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="platforms"
      data-testid="social-grid"
      className="py-16 sm:py-24 bg-slate-50 dark:bg-slate-900/50 border-y border-slate-200 dark:border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader
          title={t.platforms.title}
          subtitle={t.platforms.subtitle}
        />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mt-12">
          {platforms.map((p, i) => {
            const Icon = icons[p.id];
            return (
              <motion.a
                key={p.id}
                data-testid={`platform-card-${p.id}`}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="group relative bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-4 sm:p-6 hover:border-slate-950 dark:hover:border-cyan-400 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between">
                  <span
                    className="inline-flex h-12 w-12 items-center justify-center rounded-lg text-white overflow-hidden shrink-0"
                    style={{ backgroundColor: p.brand }}
                  >
                    {p.id === "tiktok" ? (
                      <span className="relative inline-block h-7 w-7">
                        <FaTiktok className="absolute inset-0 h-7 w-7 text-[#25F4EE] translate-x-[1.5px] -translate-y-[1px]" />
                        <FaTiktok className="absolute inset-0 h-7 w-7 text-[#FE2C55] -translate-x-[1.5px] translate-y-[1px]" />
                        <FaTiktok className="absolute inset-0 h-7 w-7 text-white" />
                      </span>
                    ) : (
                      <Icon
                        className="h-7 w-7"
                        style={p.id === "snapchat" ? { color: "#000" } : undefined}
                      />
                    )}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 dark:text-slate-600 group-hover:text-cyan-500 transition-colors" />
                </div>
                <div className="mt-5 font-heading text-2xl sm:text-3xl font-black text-slate-950 dark:text-white">
                  {p.count}
                </div>
                <div className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 mt-1">
                  {p.metric[lang]}
                </div>
                <div className="mt-4 pt-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between gap-1">
                  <span className="font-bold text-slate-950 dark:text-white text-sm sm:text-base truncate">{p.name[lang]}</span>
                  <span className="hidden sm:inline text-xs text-slate-400 dark:text-slate-500 truncate">{p.handle}</span>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
